import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { IEvent } from "models/Event";
import moment from "moment";
import { Event } from "models";
import { useDispatch } from "react-redux";
import { actions } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleDivider: {
      alignSelf: "center",
      borderRadius: "2px",
      margin: "10px 0 15px 0",
    },
    img: {
      borderBottom: "1px solid black",
    },
    title: {
      fontWeight: "bold",
    },
    date: {
      fontWeight: "bold",
      fontSize: 12,
    },
    iconButtonText: {
      marginRight: "1em",
    },
    cardContent: {
      paddingBottom: "0!important",
    },
    cardActions: {
      margin: "10px 0",
    },
  }),
);

const useEventCard = (event: Event) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      cardContent: {
        root: styles.cardContent,
      },
      actions: {
        root: styles.cardActions,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const dispatch = useDispatch();
  const [t] = useTypedTranslations();

  const openEditDialog = useCallback(
    (editMode: boolean) => {
      dispatch(
        actions.setEditEventDialogState({
          isOpen: true,
          editMode: editMode,
          selectedEvent: event,
        }),
      );
    },
    [dispatch, event],
  );

  const remainingTime = useMemo(() => {
    const ending = moment(event.expire).fromNow();
    return (ending.includes("fa") ? `Terminato ` : "Terminerà ") + `${ending}`;
  }, [event.expire]);

  return {
    styles,
    classes,
    atomicStyles,
    remainingTime,
    openEditDialog,
    t,
  };
};

export { useEventCard as default };
